// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExamInfoBar_wrapper__1MqnL"};